export const SPELL_CHECK_REQUESTED = 'SPELL_CHECK_REQUESTED';
export const SPELL_CHECK_SUCCEED = 'SPELL_CHECK_SUCCEED';
export const SPELL_CHECK_FAILED = 'SPELL_CHECK_FAILED';

export const SPELL_CHECK_REPLACE = 'SPELL_CHECK_REPLACE';

export const SPELL_CHECK_REMOVE_SPELLING = 'SPELL_CHECK_REMOVE_SPELLING';
